import { ComponentProps } from 'react';
import Image from 'react-bootstrap/Image';
import LogoFullColorImgSrc from '../../../../assets/images/sendit-logo-full-color.svg';
import LogoFullWhiteColorImgSrc from '../../../../assets/images/sendit-logo-full-white-color.svg';
import LogoMobileColorImgSrc from '../../../../assets/images/sendit-logo-mark-color.svg';
import LogoMobileWhiteImgSrc from '../../../../assets/images/sendit-logo-mark-white.svg';

interface LogoProps extends ComponentProps<typeof Image> {
  variant?: 'white' | 'color';
  useMobileLogo?: boolean;
}

export function Logo({
  className = '',
  variant = 'white',
  useMobileLogo = false,
  ...props
}: LogoProps) {
  const logoSrc = variant === 'color' ? LogoFullColorImgSrc : LogoFullWhiteColorImgSrc;
  const logoMobileSrc = variant === 'color' ? LogoMobileColorImgSrc : LogoMobileWhiteImgSrc;

  return (
    <>
      <Image
        alt="Sendit logo"
        className={`d-inline-block ${className}`}
        id="logo-full"
        src={logoSrc}
        {...props}
      />

      <Image
        alt="Sendit logo"
        className={`d-inline-block ${className}`}
        id="logo-mobile"
        src={useMobileLogo ? logoMobileSrc : logoSrc}
        {...props}
      />
    </>
  );
}
